export { Checkbox } from "@mantine/core";
export type { CheckboxProps, CheckboxGroupProps } from "@mantine/core";
export { getCheckboxOverrides } from "./Checkbox.styled";
